import {FormikSelect} from '@flexinet/ui-components';
import {useMeters} from '../hooks/useMeters.ts';
import {Meter} from '../types';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';


export const ComponentsDropdown = (props: FieldProps & SelectProps) => {

    const {items} = useMeters();

    const selectOptions = items.map((app: Meter) => {
        return {
            value: app.id,
            label: app.name,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
